<template>
    <div v-if="result" class="sale-card-counter">
        <div class="sale-card-counter__image" :style="`background-image: url('${getPicture.src}')`"></div>
        <div class="sale-card-counter__inform">
            <h3 v-if="result.name" class="def-title-3">{{result.name}}</h3>
            <div class="sale-card-counter__text">
                <div v-if="result.previewText" v-html="result.previewText"></div>
                <!--<div v-if="result.detailText" v-html="result.detailText"></div>-->
                <p v-for="item in result.sale">{{item}}</p>
            </div>
            <div class="sale-card-counter__days">
                <p v-if="result.daysLeft" class="sale-card-counter__left">{{result.daysLeft}}</p>
            </div>
            <div class="sale-card-counter__footer">
                <time-remaining :result="result" :messages="messages" />
                <div>
                    {{result.lastDay}}
                </div>
            </div>
<!--            <a v-if="result.detailPage && messages.detailText"-->
<!--               :href="result.detailPage"-->
<!--               class="def-button"-->
<!--               :class="{'sale-card__over-button':result.over}"-->
<!--            >-->
<!--                {{messages.detailText}}-->
<!--            </a>-->
        </div>
    </div>
</template>

<script>
    export default {
        name: 'sale-card-counter',
        selector: '.sale-card-counter',
        props: {
            result: {
                type: Object,
                default: () => ({
                    picture: {
                        desktop: {
                            src: '/local/templates/love-you/images/front-end/sale-detail/sale-detail-banner.png',
                            alt: 'poster'
                        },
                        tablet: {
                            src: '/local/templates/love-you/images/front-end/sale-detail/sale-detail-banner-tablet.png',
                            alt: 'poster'
                        },
                        mobile: {
                            src: '/local/templates/love-you/images/front-end/sale-detail/sale-detail-banner-mobile.png',
                            alt: 'poster'
                        }
                    },
                    name: 'WOW вікенд! До -30% на всі підвіски та кольє',
                    previewText: [
                        '-15% на розділ з підвісками',
                        '-20% на розділ з кольє',
                        '-30% при купівлі двох прикрас з акциіонних розділів'
                    ],
                    daysLeft: 'До закінчення акції залишилось',
                    lastDay: 'Діє до 6.07.2020',
                    // detailPage: '/text/'
                })
            },
            messages: {
                type: Object,
                default: () => ({
                    detailText: 'Детальніше'
                })
            }
        },
        computed: {
            getPicture() {
                try {
                    const picture = this.result.picture;
                    let currentPicture = this.result.picture.desktop;
                    if (window.innerWidth < 576 && picture.mobile) {
                        currentPicture = picture.mobile;
                    } else if (window.innerWidth < 992 && picture.tablet) {
                        currentPicture = picture.tablet;
                    }
                    // else if (window.innerWidth >= 576 && window.innerWidth < 768 && picture.table && picture.table.src) {
                    //     src = picture.table.src;
                    // }
                    // console.log(window.innerWidth >= 768, window.innerWidth < 992, picture);
                    // return `background-image: url('${src}')`;
                    return currentPicture;
                } catch (err) {
                    console.error(err);
                }
            }
        },
        mounted() {
            if (App.debug) {
                console.log('Component: sale-card-counter', this);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .sale-card-counter{
        display: grid;
        grid-template-columns: 1fr;
        margin-bottom: 80px;
        overflow: hidden;
        //position: relative;
        @include point-lg{
            grid-template-columns: repeat(2, 1fr);
        }
        &__inform{
            display: flex;
            flex-direction: column;
            padding: 40px 20px 20px;
            background-color: #fff;
            min-height: 308px;
            @include point-md{
                padding: 40px;
            }
            @include point-lg{
                padding: 48px;
                min-height: 368px;
            }
        }
        &__days{
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;
            align-items: center;
        }
        &__image{
            height: 272px;
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
            position: relative;
            //box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.1);
            position: relative;
            @include point-lg{
                height: 100%;
            }
            img{
                display: block;
                max-width: 100%;
                width: 100%;
            }
            &:after{
                content: '';
                display: block;
                width: 48px;
                height: 48px;
                background-color: #f7f8f9;
                position: absolute;
                bottom: 0;
                transform: translate(-50%, 50%);
                border-radius: 50%;
                @include point-lg{
                    width: 64px;
                    height: 64px;
                    right: 0;
                    transform: translate(50%, -50%);
                    bottom: unset;
                }
            }
            &:before{
                content: '';
                display: block;
                width: 48px;
                height: 48px;
                background-color: #f7f8f9;
                position: absolute;
                right: 0;
                bottom: 0;
                transform: translate(50%, 50%);
                border-radius: 50%;
                @include point-lg{
                    width: 64px;
                    height: 64px;
                    //bottom: unset;
                    //transform: translate(50%, -50%);
                }
            }
        }
        &__left{
            font-size: rem(14);
            line-height: 110%;
            color: #191918;
            @include point-md{
                font-size: rem(16);
            }
        }
        &__day{
            font-weight: 700;
            font-size: rem(24);
            color: var(--text-colour-primary);
            @include point-lg{
                font-size: rem(32);
            }
            @include point-lg{
                font-size: rem(40);
            }
        }
        &__text{
            font-weight: 500;
            font-size: rem(16);
            line-height: 120%;
            color: #363636;
            @include point-md{
                font-size: rem(18);
            }
            margin-bottom: auto;
        }
        &__last-day{
            font-size: rem(18);
            color: #191918;
        }
        &__footer{
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            @include point-md{
                flex-direction: row;
                align-items: flex-end;
            }
        }
        .def-title-3{
            font-size: rem(16);
            margin-bottom: 16px;
            @include point-md{
                font-size: rem(18);
            }
            @include point-lg{
                font-size: rem(24);
            }
        }
    }
</style>